// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.loading {
  visibility: hidden;
}

body, html, #root {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;
}

.app {
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100%;
  overflow-y: hidden;
  background: linear-gradient(to bottom, #f0f8ff, #ffffff); /* Very light blue gradient from top to bottom */
}

.body{
  display: flex;
  flex-direction: column;
  width: 100%;
  background:#F9F9F9  ;
}

.bodyGuest{
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, #8859d9, #4c6bf5); /* Purple gradient */

}

.bodyHeader {
  padding: 8px;
  padding-bottom: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.bodyHeaderGuest {
  padding: 12px;
  display: flex;
  height: 220px;
  flex-direction: column;
  align-items: center;
}

.bodyHeaderGuestComp{
  padding: 8px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
}

.GuestIconContainer{
  width: 80px;
  height: 80px;
  background-color: white;
  border-radius: 50%;
  margin-left: 16px;
  margin-top: 25px;
}

.GuestIconContainerComp{
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 50%;
  margin-left: 0px;
}
.heading{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.GuestIcon{
 width: 80%;
 height: 80%;
 margin-left: 8px;
 margin-top: 8px;
 
}
.GuestIconComp{
  width: 80%;
  height: 80%;
  margin-left: 4.5px;
  margin-top: 4.5px;
}

.chatName {
  display: flex;
  flex-direction: row;
  font-size: 22px;
  margin-top: 16px;
  margin-left: 16px;
  font-weight: 700;
  color: #1B2559;
  font-family: 'Roboto', sans-serif;
  justify-content: center;
  align-items: center;
}

.chatName p{
  margin-bottom: 0;
  margin-left: 5px;
}

.chatLogo{
  width: 40px;
  height: 40px;
}

.searchbar{

}

.containtBox{
  display: flex;
  padding-bottom: 0px;
  height: 100%;
  width: 100%;
  flex-direction: column;
}
.containtBoxGuest{
  display: flex;
  padding-bottom: 0px;
  height: 100%;
  width: 97%;
  border-radius: 16px;
  background-color: white;
  flex-direction: column;
}
.main-content {
  flex-grow: 1; /* This allows the main content to take up the remaining height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow-y: hidden; /* Ensures that the content is scrollable */
  box-sizing: border-box;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
  .main-content-container {
    padding: 10px;
  }

  .upload-box-container,
  .chat-box-container {
    padding: 0 10px;
  }

  .header {
    height: 50px; /* Adjust height for smaller screens */
    padding: 0 10px;
  }
}

@media (max-width: 560px) {
  .body{
  }
  .header {
    height: 50px; /* Further adjust height for very small screens */
    padding: 0 5px;
  }

  .upload-box-container,
  .chat-box-container {
    max-width: 100%;
    margin: 10px auto;
    margin-top: 0px;
    padding: 0 5px;
  }
  .chatName{
    font-size: 16px;
    margin-top: 0px;
  }
}
body.dark-mode,
body.dark-mode #root,
body.dark-mode .body {
  background-color: #1e1e1e; /* Dark background */
}

body.dark-mode .bodyGuest {
  background-color: #1e1e1e; /* Dark background */
}

body.dark-mode .app {
  background: linear-gradient(to bottom, #121212, #1e1e1e); /* Dark gradient background */
  color: #e0e0e0;
}

body.dark-mode .header {
  background-color: transparent;
  color: #ffffff;
}

body.dark-mode .main-content-container {
  background: linear-gradient(to bottom, #1a1a1a, #2a2a2a); /* Darker gradient */
}

body.dark-mode .chatName {
  color: #bbbbbb;
}

body.dark-mode .chat-box {
  background-color: #333333;
  color: #e0e0e0;
}

body.dark-mode .file-input-label i {
  color: #e0e0e0;
}

body.dark-mode .send-button {
  color: #e0e0e0;
}

body.dark-mode .send-button:hover {
  color: #ffffff;
}

/* Responsive design adjustments for dark mode */
@media (max-width: 768px) {
  body.dark-mode .main-content-container {
    padding: 10px;
  }

  body.dark-mode .upload-box-container,
  body.dark-mode .chat-box-container {
    padding: 0 10px;
  }

  body.dark-mode .header {
    height: 50px;
    padding: 0 10px;
  }
  .containtBox{
    width: 100%;
  }
  .chatName {
    font-size: 18px;
  }
  .chatLogo{
    width: 35px;
    height: 35px;
  }
}

@media (max-width: 480px) {
  body.dark-mode .header {
    height: 50px;
    padding: 0 5px;
  }

  body.dark-mode .upload-box-container,
  body.dark-mode .chat-box-container {
    max-width: 100%;
    margin: 10px auto;
    padding: 0 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uIAAuI;AACzI;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wDAAwD,EAAE,gDAAgD;AAC5G;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,uDAAuD,EAAE,oBAAoB;;AAE/E;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,gBAAgB;CAChB,eAAe;;AAEhB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,YAAY,EAAE,iEAAiE;EAC/E,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAE,2CAA2C;EAC/D,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY,EAAE,sCAAsC;IACpD,eAAe;EACjB;AACF;;AAEA;EACE;EACA;EACA;IACE,YAAY,EAAE,iDAAiD;IAC/D,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,eAAe;EACjB;AACF;AACA;;;EAGE,yBAAyB,EAAE,oBAAoB;AACjD;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;AACjD;;AAEA;EACE,wDAAwD,EAAE,6BAA6B;EACvF,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,wDAAwD,EAAE,oBAAoB;AAChF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;AACF","sourcesContent":["body.loading {\n  visibility: hidden;\n}\n\nbody, html, #root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;\n}\n\n.app {\n  display: flex;\n  flex-direction: row;\n  width: 100vw;\n  height: 100%;\n  overflow-y: hidden;\n  background: linear-gradient(to bottom, #f0f8ff, #ffffff); /* Very light blue gradient from top to bottom */\n}\n\n.body{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background:#F9F9F9  ;\n}\n\n.bodyGuest{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(to right, #8859d9, #4c6bf5); /* Purple gradient */\n\n}\n\n.bodyHeader {\n  padding: 8px;\n  padding-bottom: 0px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bodyHeaderGuest {\n  padding: 12px;\n  display: flex;\n  height: 220px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.bodyHeaderGuestComp{\n  padding: 8px;\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n}\n\n.GuestIconContainer{\n  width: 80px;\n  height: 80px;\n  background-color: white;\n  border-radius: 50%;\n  margin-left: 16px;\n  margin-top: 25px;\n}\n\n.GuestIconContainerComp{\n  width: 40px;\n  height: 40px;\n  background-color: white;\n  border-radius: 50%;\n  margin-left: 0px;\n}\n.heading{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.GuestIcon{\n width: 80%;\n height: 80%;\n margin-left: 8px;\n margin-top: 8px;\n \n}\n.GuestIconComp{\n  width: 80%;\n  height: 80%;\n  margin-left: 4.5px;\n  margin-top: 4.5px;\n}\n\n.chatName {\n  display: flex;\n  flex-direction: row;\n  font-size: 22px;\n  margin-top: 16px;\n  margin-left: 16px;\n  font-weight: 700;\n  color: #1B2559;\n  font-family: 'Roboto', sans-serif;\n  justify-content: center;\n  align-items: center;\n}\n\n.chatName p{\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n\n.chatLogo{\n  width: 40px;\n  height: 40px;\n}\n\n.searchbar{\n\n}\n\n.containtBox{\n  display: flex;\n  padding-bottom: 0px;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n}\n.containtBoxGuest{\n  display: flex;\n  padding-bottom: 0px;\n  height: 100%;\n  width: 97%;\n  border-radius: 16px;\n  background-color: white;\n  flex-direction: column;\n}\n.main-content {\n  flex-grow: 1; /* This allows the main content to take up the remaining height */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  overflow-y: hidden; /* Ensures that the content is scrollable */\n  box-sizing: border-box;\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 768px) {\n  .main-content-container {\n    padding: 10px;\n  }\n\n  .upload-box-container,\n  .chat-box-container {\n    padding: 0 10px;\n  }\n\n  .header {\n    height: 50px; /* Adjust height for smaller screens */\n    padding: 0 10px;\n  }\n}\n\n@media (max-width: 560px) {\n  .body{\n  }\n  .header {\n    height: 50px; /* Further adjust height for very small screens */\n    padding: 0 5px;\n  }\n\n  .upload-box-container,\n  .chat-box-container {\n    max-width: 100%;\n    margin: 10px auto;\n    margin-top: 0px;\n    padding: 0 5px;\n  }\n  .chatName{\n    font-size: 16px;\n    margin-top: 0px;\n  }\n}\nbody.dark-mode,\nbody.dark-mode #root,\nbody.dark-mode .body {\n  background-color: #1e1e1e; /* Dark background */\n}\n\nbody.dark-mode .bodyGuest {\n  background-color: #1e1e1e; /* Dark background */\n}\n\nbody.dark-mode .app {\n  background: linear-gradient(to bottom, #121212, #1e1e1e); /* Dark gradient background */\n  color: #e0e0e0;\n}\n\nbody.dark-mode .header {\n  background-color: transparent;\n  color: #ffffff;\n}\n\nbody.dark-mode .main-content-container {\n  background: linear-gradient(to bottom, #1a1a1a, #2a2a2a); /* Darker gradient */\n}\n\nbody.dark-mode .chatName {\n  color: #bbbbbb;\n}\n\nbody.dark-mode .chat-box {\n  background-color: #333333;\n  color: #e0e0e0;\n}\n\nbody.dark-mode .file-input-label i {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .send-button {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .send-button:hover {\n  color: #ffffff;\n}\n\n/* Responsive design adjustments for dark mode */\n@media (max-width: 768px) {\n  body.dark-mode .main-content-container {\n    padding: 10px;\n  }\n\n  body.dark-mode .upload-box-container,\n  body.dark-mode .chat-box-container {\n    padding: 0 10px;\n  }\n\n  body.dark-mode .header {\n    height: 50px;\n    padding: 0 10px;\n  }\n  .containtBox{\n    width: 100%;\n  }\n  .chatName {\n    font-size: 18px;\n  }\n  .chatLogo{\n    width: 35px;\n    height: 35px;\n  }\n}\n\n@media (max-width: 480px) {\n  body.dark-mode .header {\n    height: 50px;\n    padding: 0 5px;\n  }\n\n  body.dark-mode .upload-box-container,\n  body.dark-mode .chat-box-container {\n    max-width: 100%;\n    margin: 10px auto;\n    padding: 0 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
